
import React, { useEffect } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { styled } from '@mui/material';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Poster from '../Images/Poster.png'
import Icon_1 from '../Images/Icon_1.png';
import LineDotted from '../Images/LineDotted.png'
import Underline_1 from '../Images/Underline_1.png';
import Icon_2 from '../Images/Icon_2.png';
import Underline_2 from '../Images/Underline_2.png';
import Icon_3 from '../Images/Icon_3.png';
import Underline_3 from '../Images/Underline_3.png';
import map from '../Images/map.png';
import qot from '../Images/qot.png';
import man from '../Images/man.png';
import man_2 from '../Images/man_2.png';
import map_2 from '../Images/map_2.png';
import add from '../Images/add.png';
import Link from '@mui/material/Link';
import footer_twitter_icon from '../Images/Footer_twitter.png';
import footer_insta_icon from '../Images/Footer_insta.png';
import footer_facebook_icon from '../Images/footer_facebook.png';
import appstore from '../Images/appStore.png';
import googleStore from '../Images/googleStore.png';
import line from '../Images/line.png';
import Vector_1 from '../Images/Vector_1.png'
import Vector_2 from '../Images/Vector_2.png';
import Vector_3 from '../Images/Vector_3.png';
import Vector_4 from '../Images/Vector_4.png';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../style.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useGetAllContentsMutation } from 'api/content';

var settings = {
  dots: true,
  infinite: false,
  speed: 400,
  slidesToShow: 1,
  slidesToScroll: 4,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}

const Heading = styled(Typography)(({ theme }) => ({
  color: "#00000",
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: "600",
  letterSpacing: "-0.01em;",
  lineHeight: '160%'

}));

const SubHeading = styled(Typography)(({ theme }) => ({
  color: "#1A1824",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: '40px',
  lineHeight: '140%'

}))

const SubHeading_2 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Outfit',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '24px',
  lineHeight: '30px',
  color: '#1A1824'

}))

const Para = styled(Typography)(({ theme }) => ({
  color: "#545359",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "400",
}))

const Btn = styled(Button)((theme) => ({
  padding: "11px 20px",
  width: "176px",
  hegight: "48px",
  borderRadius: "4px",
  backgroundColor: "#2B817B;",
  color: "white",
  margin: "50px 0px 0px 20px",
}))
const SubHeading_3 = styled(Typography)((theme) => ({
  fontFamily: 'Outfit',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '32px',
  lineHeight: '38px',
  color: '#1A1824;'

}))

function About_EatCoast() {
  return (
    <>
      <Container sx={{ marginTop: 10 }} maxWidth="lg">
        <Heading
          sx={{
            fontSize: { lg: "56px", md: "40px", sm: "30", xs: "30px" },
            textAlign: 'center',

          }}
        >
          About Eatcoast
        </Heading>
        <Para
          sx={{
            textAlign: "center",
            fontSize: '20px'
          }}
        >
          Lorem Ipsum is simply dummy text of the printing and <br />{" "}
          typesetting industry. Lorem Ipsum has been
        </Para>
      </Container>
      <Container sx={{ marginTop: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }} maxWidth>

        <center>
          <img id='about_poster' width="1290px" src={Poster} />

        </center>

      </Container>
    </>
  )
}







function HowItWorks() {
  return (
    <>
      <Container sx={{ marginTop: 10 }} maxWidth="xl">
        <SubHeading sx={{ textAlign: 'center', fontSize: { lg: '40px', md: '40px', sm: '25px', xs: '25px' } }}>How It Works?</SubHeading>
      </Container>

      <Container
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          marginTop: 10,
        }}
        maxWidth="xl"
      >
        <Box sx={{ marginBottom: 5 }}>
          <img src={Icon_1} />
          <SubHeading_2>
            Choose Meal Plans{" "}
            <img style={{ marginLeft: "10px" }} src={LineDotted} />
          </SubHeading_2>
          <Para sx={{ fontSize: '14px' }}>
            Lorem Ipsum is simply dummy text of the <br /> printing and
            typesetting industry.{" "}
          </Para>
          <img src={Underline_1} />
        </Box>
        <Box sx={{ marginBottom: 5 }}>
          <img src={Icon_2} />
          <SubHeading_2>
            Select Order Type{" "}
            <img style={{ marginLeft: "10px" }} src={LineDotted} />
          </SubHeading_2>
          <Para sx={{ fontSize: '14px' }}>
            Lorem Ipsum is simply dummy text of the <br /> printing and
            typesetting industry.{" "}
          </Para>
          <img src={Underline_2} />
        </Box>
        <Box sx={{ marginBottom: 5 }}>
          <img src={Icon_3} />
          <SubHeading_2> Delivered To Yo</SubHeading_2>
          <Para sx={{ fontSize: '14px' }}>
            Lorem Ipsum is simply dummy text of the <br /> printing and
            typesetting industry.{" "}
          </Para>
          <img src={Underline_3} />
        </Box>
      </Container>
    </>
  )
}




function Partners() {
  return (
    <>
      <Box sx={{
        width: '100%',
        display: 'flex',
        flexDirection: { xl: 'row', lg: 'row', md: 'row', sm: 'column', xs: 'column' },
        justifyContent: { xl: 'space-around', lg: 'space-between', md: 'space-between', sm: 'center' },
        margin: { xl: '0px', lg: '20px' },
      }}>
        <Box sx={{ marginTop: 5 }}>
          <SubHeading sx={{ fontSize: { lg: '40px', md: '40px', sm: '25px', xs: '25px' } }}>Our more than 250 <br /> partners spread across Canada</SubHeading>
          <Para sx={{ fontSize: '18px' }}>Lorem Ipsum is simply dummy text of the printing <br />
            and typesetting industry. Lorem Ipsum has been</Para>
        </Box>
        <Box>
          <img id='partners_map' src={map} width="98%" />
        </Box>
      </Box>
    </>
  )
}

function WhyChoseUs() {
  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: { xl: 'row', lg: 'row', md: 'row', sm: 'column', xs: 'column' },
          justifyContent: { xl: 'space-evenly', lg: 'space-between', md: 'space-between', sm: 'center' },
          margin: { lg: '10px', md: '10px', sm: '2px', xs: '0px' },
        }}>
        <Box>
          <SubHeading sx={{ fontSize: { lg: '40px', md: '40px', sm: '25px', xs: '25px' } }}> Why choose us?</SubHeading>
          <Para sx={{ fontSize: "18px", textAlign: 'justify' }}>
            Lorem Ipsum is simply dummy text of the <br /> printing and
            typesetting industry.{" "}
          </Para>
          <Btn className='orderBtn'>Order Now</Btn>
        </Box>
        <Box>

          <Box sx={{
            display: "flex",
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Box
              sx={{
                width: "auto",
                height: "156px",
                backgroundColor: "#F6F6F6",
                borderRadius: "6px",
                padding: 3,
                margin: 2
              }}
              className='box'
            >
              <img src={Vector_1} />

              <SubHeading_2>Best Choice of Cuisine</SubHeading_2>
              <Para sx={{ fontSize: '14px' }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </Para>
            </Box>

            <Box
              sx={{
                width: "auto",
                height: "156px",
                backgroundColor: "#F6F6F6",
                borderRadius: "6px",
                padding: 3,
                margin: 2
              }}
              className='box'
            >
              <img src={Vector_2} />
              <SubHeading_2>Delivered Quickly</SubHeading_2>
              <Para sx={{ fontSize: '14px' }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </Para>
            </Box>
          </Box>


          <Box sx={{
            display: "flex",
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 5,
          }}>
            <Box
              sx={{
                width: "auto",
                height: "156px",
                backgroundColor: "#F6F6F6",
                borderRadius: "6px",
                padding: 3,
                margin: 2
              }}
              className='box'
            >
              <img src={Vector_3} />
              <SubHeading_2>Trusted Service</SubHeading_2>
              <Para sx={{ fontSize: '14px' }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </Para>
            </Box>

            <Box
              sx={{
                width: "auto",
                height: "156px",
                backgroundColor: "#F6F6F6",
                borderRadius: "6px",
                padding: 3,
                margin: 2

              }}
              className='box'
            >
              <img src={Vector_4} />
              <SubHeading_2>Various Subscription</SubHeading_2>
              <Para sx={{ fontSize: '14px' }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </Para>
            </Box>

          </Box>

        </Box>
      </Box>

    </>
  )
}







function Slider_Component() {
  return (
    <>
      <Container sx={{ marginTop: 10, dispaly: 'flex', justifyContent: 'center' }} maxWidth="md">

        <center>

          <Slider {...settings}>
            <Box>
              <img src={qot} />
              <Para className='sliderPara' sx={{ textAlign: 'center', width: '570px', fontSize: '18px' }}>Lorem Ipsum is simply dummy text
                of the printing and typesetting industry.Lorem Ipsum is simply
                dummy text of the printing and typesetting  industry.  </Para>
              <img style={{ marginTop: 10 }} src={man} />
              <SubHeading_2>Mendy Berliana</SubHeading_2>
              <Para sx={{ fontSize: '16px' }}>Senior Director</Para>
            </Box>


            <Box>
              <img src={qot} />
              <Para className='sliderPara' sx={{ textAlign: 'center', width: '570px', fontSize: '18px' }}>Lorem Ipsum is simply dummy text
                of the printing and typesetting industry.Lorem Ipsum is simply
                dummy text of the printing and typesetting  industry.  </Para>
              <img style={{ marginTop: 10 }} src={man} />
              <SubHeading_2>Mendy Berliana</SubHeading_2>
              <Para sx={{ fontSize: '16px' }}>Senior Director</Para>
            </Box>
            <Box>
              <img src={qot} />
              <Para className='sliderPara' sx={{ textAlign: 'center', width: '570px', fontSize: '18px' }}>Lorem Ipsum is simply dummy text
                of the printing and typesetting industry.Lorem Ipsum is simply
                dummy text of the printing and typesetting  industry.  </Para>
              <img style={{ marginTop: 10 }} src={man} />
              <SubHeading_2>Mendy Berliana</SubHeading_2>
              <Para sx={{ fontSize: '16px' }}>Senior Director</Para>
            </Box>
            <Box>
              <img src={qot} />
              <Para className='sliderPara' sx={{ textAlign: 'center', width: '570px', fontSize: '18px' }}>Lorem Ipsum is simply dummy text
                of the printing and typesetting industry.Lorem Ipsum is simply
                dummy text of the printing and typesetting  industry.  </Para>
              <img style={{ marginTop: 10 }} src={man} />
              <SubHeading_2>Mendy Berliana</SubHeading_2>
              <Para sx={{ fontSize: '16px' }}>Senior Director</Para>
            </Box>
            <Box>
              <img src={qot} />
              <Para className='sliderPara' sx={{ textAlign: 'center', width: '570px', fontSize: '18px' }}>Lorem Ipsum is simply dummy text
                of the printing and typesetting industry.Lorem Ipsum is simply
                dummy text of the printing and typesetting  industry.  </Para>
              <img style={{ marginTop: 10 }} src={man} />
              <SubHeading_2>Mendy Berliana</SubHeading_2>
              <Para sx={{ fontSize: '16px' }}>Senior Director</Para>
            </Box>
            <Box>
              <img src={qot} />
              <Para className='sliderPara' sx={{ textAlign: 'center', width: '570px', fontSize: '18px' }}>Lorem Ipsum is simply dummy text
                of the printing and typesetting industry.Lorem Ipsum is simply
                dummy text of the printing and typesetting  industry.  </Para>
              <img style={{ marginTop: 10 }} src={man} />
              <SubHeading_2>Mendy Berliana</SubHeading_2>
              <Para sx={{ fontSize: '16px' }}>Senior Director</Para>
            </Box>
            <Box>
              <img src={qot} />
              <Para className='sliderPara' sx={{ textAlign: 'center', width: '570px', fontSize: '18px' }}>Lorem Ipsum is simply dummy text
                of the printing and typesetting industry.Lorem Ipsum is simply
                dummy text of the printing and typesetting  industry.  </Para>
              <img style={{ marginTop: 10 }} src={man} />
              <SubHeading_2>Mendy Berliana</SubHeading_2>
              <Para sx={{ fontSize: '16px' }}>Senior Director</Para>
            </Box>
            <Box>
              <img src={qot} />
              <Para className='sliderPara' sx={{ textAlign: 'center', width: '570px', fontSize: '18px' }}>Lorem Ipsum is simply dummy text
                of the printing and typesetting industry.Lorem Ipsum is simply
                dummy text of the printing and typesetting  industry.  </Para>
              <img style={{ marginTop: 10 }} src={man} />
              <SubHeading_2>Mendy Berliana</SubHeading_2>
              <Para sx={{ fontSize: '16px' }}>Senior Director</Para>
            </Box>
            <Box>
              <img src={qot} />
              <Para className='sliderPara' sx={{ textAlign: 'center', width: '570px', fontSize: '18px' }}>Lorem Ipsum is simply dummy text
                of the printing and typesetting industry.Lorem Ipsum is simply
                dummy text of the printing and typesetting  industry.  </Para>
              <img style={{ marginTop: 10 }} src={man} />
              <SubHeading_2>Mendy Berliana</SubHeading_2>
              <Para sx={{ fontSize: '16px' }}>Senior Director</Para>
            </Box>
            <Box>
              <img src={qot} />
              <Para className='sliderPara' sx={{ textAlign: 'center', width: '570px', fontSize: '18px' }}>Lorem Ipsum is simply dummy text
                of the printing and typesetting industry.Lorem Ipsum is simply
                dummy text of the printing and typesetting  industry.  </Para>
              <img style={{ marginTop: 10 }} src={man} />
              <SubHeading_2>Mendy Berliana</SubHeading_2>
              <Para sx={{ fontSize: '16px' }}>Senior Director</Para>
            </Box>

          </Slider>
        </center>








      </Container>





    </>
  )
}


function OurTeam() {
  return (
    <>
      <Container sx={{ marginTop: 10 }} maxWidth>
        <center>
          <SubHeading sx={{ fontSize: { lg: '32px', md: '28px', sm: '20px', xs: '20px' } }}>Meet Our Team</SubHeading>
          <Para sx={{ fontSize: '18px', marginTop: 1 }}>Lorem Ipsum is simply dummy text of the printing </Para>
        </center>
        <Container className="ourTeam" sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginTop: 10 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 5 }}>
            <img src={man_2} />
            <SubHeading_3 sx={{ fontSize: { lg: '32px', md: '28px', sm: '20px', xs: '20px' } }}>Mendy Berliana</SubHeading_3>
            <Para sx={{ fontSize: '20px' }}>Senior Director</Para>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 5 }}>
            <img src={man_2} />
            <SubHeading_3 sx={{ fontSize: { lg: '32px', md: '28px', sm: '20px', xs: '20px' } }}>Mendy Berliana</SubHeading_3>
            <Para sx={{ fontSize: '20px' }}>Senior Director</Para>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 5 }}>
            <img src={man_2} />
            <SubHeading_3 sx={{ fontSize: { lg: '32px', md: '28px', sm: '20px', xs: '20px' } }}>Mendy Berliana</SubHeading_3>
            <Para sx={{ fontSize: '20px' }}>Senior Director</Para>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 5 }}>
            <img src={man_2} />
            <SubHeading_3 sx={{ fontSize: { lg: '32px', md: '28px', sm: '20px', xs: '20px' } }}>Mendy Berliana</SubHeading_3>
            <Para sx={{ fontSize: '20px' }}>Senior Director</Para>
          </Box>

        </Container>
      </Container>
    </>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function OurLocation() {

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Container sx={{ marginTop: 10, display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }} maxWidth="xl">
        <Box>
          <SubHeading_2>Our Location</SubHeading_2>
          <Para sx={{ fontSize: '18px' }}>Lorem Ipsum is simply dummy text of the printing and <br />
            typesetting industry. Lorem Ipsum has been</Para>
          <Btn>Order Now</Btn>
        </Box>
        <Box className='mapContainer'>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab sx={{
                  fontSize: { lg: '15px', md: '15px', sm: '14px', xs: '14px' },
                  color: 'black',
                  fontWeight: '600'
                }} label="Greater Vancouver" {...a11yProps(0)} />
                <Tab sx={{
                  fontSize: { lg: '15px', md: '15px', sm: '14px', xs: '14px' },
                  color: 'black',
                  fontWeight: '600'
                }} label="Victoria" {...a11yProps(1)} />
                {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <Box>
                <img id='map_2' style={{ display: 'block' }} src={map_2} />
                <Para sx={{ fontSize: { lg: '20px', md: '20px', sm: '14px', xs: '14px' }, fontWeight: '600', color: '#1A1824' }}>Greater Vancouver, Canada</Para>
                <Para sx={{ fontSize: { lg: '18px', md: '18px', sm: '14px', xs: '14px' } }}>547 rue des Champs <br /> G7H 4N3</Para>
              </Box>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Box>
                <img id='map_2' style={{ display: 'block' }} src={map_2} />
                <Para sx={{ fontSize: { lg: '20px', md: '20px', sm: '14px', xs: '14px' }, fontWeight: '600', color: '#1A1824' }}>Victoria, Canada</Para>
                <Para sx={{ fontSize: { lg: '18px', md: '18px', sm: '14px', xs: '14px' } }}>547 rue des Champs <br /> G7H 4N3</Para>
              </Box>
            </TabPanel>
            {/* <TabPanel value={value} index={2}>
            Item Three
          </TabPanel> */}
          </Box>
        </Box>
      </Container>
    </>
  )
}



function FAQ() {

  const [getAllFaqs] = useGetAllContentsMutation()
  const [faQs, setFaQs] = React.useState([])
  useEffect(() => {
    getAllFaqs({ type: "faqs" }).then((res) => {
      console.log("res", res.data.data)
      setFaQs(res.data.data)
    })
  }, [])


  return (
    <>
      <Container maxWidth>
        <SubHeading_2 sx={{ textAlign: 'center', marginTop: 5 }}>FAQ</SubHeading_2>
      </Container>
      <Container className='FAQ' sx={{ marginTop: 10, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', }} maxWidth="lg">
        <Box className="marginBox" sx={{}}>

          {faQs.length > 0 && faQs.map((faq) => (

            <Box sx={{ mb: 2 }}>
              <Accordion sx={{ width: { lg: '536px', md: '536px', sm: '400px', xs: '300px' }, backgroundColor: '#F6F6F6', border: '1px solid #D5E6E5;', }}>
                <AccordionSummary
                  expandIcon={<AddIcon sx={{ color: '#2B817B' }} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography sx={{ fontSize: { lg: '18px', md: '18px', sm: '12px', xs: '12px' }, fontWeight: '600' }}>{faq?.title} ?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {faq?.response}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Box>
          ))

          }

          {/* <Box sx={{ mt: '15px' }}>
            <Accordion sx={{ width: { lg: '536px', md: '536px', sm: '400px', xs: '300px' }, backgroundColor: '#F6F6F6', border: '1px solid #D5E6E5;', }}>
              <AccordionSummary
                expandIcon={<AddIcon sx={{ color: '#2B817B' }} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontSize: { lg: '18px', md: '18px', sm: '12px', xs: '12px' }, fontWeight: '600' }}>Why can’t i find restaurants in my area ?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                  malesuada lacus ex, sit amet blandit leo lobortis eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Box>
          <Box sx={{ mt: '15px' }}>
            <Accordion sx={{ width: { lg: '536px', md: '536px', sm: '400px', xs: '300px' }, backgroundColor: '#F6F6F6', border: '1px solid #D5E6E5;', }}>
              <AccordionSummary
                expandIcon={<AddIcon sx={{ color: '#2B817B' }} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontSize: { lg: '18px', md: '18px', sm: '12px', xs: '12px' }, fontWeight: '600' }}>How do i pay ?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                  malesuada lacus ex, sit amet blandit leo lobortis eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Box> */}

        </Box>


        {/* <Box className='marginBox'>


          <Box>
            <Accordion sx={{ width: { lg: '536px', md: '536px', sm: '400px', xs: '300px' }, backgroundColor: '#F6F6F6', border: '1px solid #D5E6E5;', }}>
              <AccordionSummary
                expandIcon={<AddIcon sx={{ color: '#2B817B' }} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontSize: { lg: '18px', md: '18px', sm: '12px', xs: '12px' }, fontWeight: '600' }}>Where can i order food throught the EatCoast service ?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                  malesuada lacus ex, sit amet blandit leo lobortis eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Box>


          <Box sx={{ mt: '15px' }}>
            <Accordion sx={{ width: { lg: '536px', md: '536px', sm: '400px', xs: '300px' }, backgroundColor: '#F6F6F6', border: '1px solid #D5E6E5;', }}>
              <AccordionSummary
                expandIcon={<AddIcon sx={{ color: '#2B817B' }} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontSize: { lg: '18px', md: '18px', sm: '12px', xs: '12px' }, fontWeight: '600' }}>How much is the delivery fee ?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                  malesuada lacus ex, sit amet blandit leo lobortis eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Box>


          <Box sx={{ mt: '15px' }}>
            <Accordion sx={{ width: { lg: '536px', md: '536px', sm: '400px', xs: '300px' }, backgroundColor: '#F6F6F6', border: '1px solid #D5E6E5;', }}>
              <AccordionSummary
                expandIcon={<AddIcon sx={{ color: '#2B817B' }} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontSize: { lg: '18px', md: '18px', sm: '12px', xs: '12px' }, fontWeight: '600' }}>What restaurants are available in my area ?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                  malesuada lacus ex, sit amet blandit leo lobortis eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Box>

          <Box sx={{ mt: '15px' }}>
            <Accordion sx={{ width: { lg: '536px', md: '536px', sm: '400px', xs: '300px' }, backgroundColor: '#F6F6F6', border: '1px solid #D5E6E5;', }}>
              <AccordionSummary
                expandIcon={<AddIcon sx={{ color: '#2B817B' }} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontSize: { lg: '18px', md: '18px', sm: '12px', xs: '12px' }, fontWeight: '600' }}>How’s subscription work ?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                  malesuada lacus ex, sit amet blandit leo lobortis eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Box>

        </Box> */}

      </Container>
    </>
  )
}

function Footer() {
  return (
    <>
      <Container className='footer' sx={{ marginTop: 10, display: 'flex', justifyContent: "space-around" }} maxWidth='xl'>
        <Box sx={{ marginBottom: { lg: '0px', md: '20px', sm: '20px', xs: '20px' } }}>
          <Typography sx={{ mt: 2, fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '600px', fontSize: "40px", lineHeight: '140%', letterSpacing: '0.01em', color: '#000000;' }}>EatCoast</Typography>
          <Typography sx={{ fontFamily: 'Outfit', fontWeight: '400', fontSize: '18px', lineHeight: '145%', LetterSpacing: '0.015em', color: ' #545359' }}>Lorem Ipsum is simply dummy text of <br /> the printing and typesetting industry.</Typography>
          <Link href="#"><img style={{ margin: '10px 10px 0px 0px' }} src={footer_twitter_icon} /></Link>
          <Link href="#"><img style={{ margin: '10px 10px 0px 0px' }} src={footer_insta_icon} /></Link>
          <Link href="#"><img style={{ margin: '10px 10px 0px 0px' }} src={footer_facebook_icon} /></Link>


        </Box>
        <Box className="footerNav">
          <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: "600", fontSize: '20px', lineHeight: '140%', letterSpacing: '0.015em', color: '#1A1824;' }}>Services</Typography>
          <Box className="footerNav" sx={{ marginTop: 5, display: 'flex', flexDirection: "column" }}>
            <Link sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lilneHeight: '145%', letterSpacing: ' 0.015em;', color: '#9EA3AE', textDecoration: 'none' }} href="#">All Menu</Link>
            <Link sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lilneHeight: '145%', letterSpacing: ' 0.015em;', color: '#9EA3AE', textDecoration: 'none', marginTop: 2 }} href="#">All Menu</Link>
            <Link sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lilneHeight: '145%', letterSpacing: ' 0.015em;', color: '#9EA3AE', textDecoration: 'none', marginTop: 2 }} href="#">Buy Git Cards</Link>
            <Link sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lilneHeight: '145%', letterSpacing: ' 0.015em;', color: '#9EA3AE', textDecoration: 'none', marginTop: 2 }} href="#">Become a Caterer</Link>
            <Link sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lilneHeight: '145%', letterSpacing: ' 0.015em;', color: '#9EA3AE', textDecoration: 'none', marginTop: 2 }} href="#">Create Business Account</Link>

          </Box>
        </Box>
        <Box className="footerNav">
          <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: "600", fontSize: '20px', lineHeight: '140%', letterSpacing: '0.015em', color: '#1A1824;' }}>Company</Typography>
          <Box sx={{ marginTop: 5, display: 'flex', flexDirection: 'column' }}>
            <Link sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lilneHeight: '145%', letterSpacing: ' 0.015em;', color: '#9EA3AE', textDecoration: 'none' }} href="#">About Us</Link>
            <Link sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lilneHeight: '145%', letterSpacing: ' 0.015em;', color: '#9EA3AE', textDecoration: 'none', marginTop: 2 }} href="#">Blog</Link>
            <Link sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lilneHeight: '145%', letterSpacing: ' 0.015em;', color: '#9EA3AE', textDecoration: 'none', marginTop: 2 }} href="#">Careers</Link>


          </Box>
        </Box>
        <Box className="footerNav">
          <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: "600", fontSize: '20px', lineHeight: '140%', letterSpacing: '0.015em', color: '#1A1824;' }}>Support</Typography>
          <Box sx={{ marginTop: 5, display: 'flex', flexDirection: 'column' }}>
            <Link sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lilneHeight: '145%', letterSpacing: ' 0.015em;', color: '#9EA3AE', textDecoration: 'none' }} href="#">FAQ</Link>
            <Link sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lilneHeight: '145%', letterSpacing: ' 0.015em;', color: '#9EA3AE', textDecoration: 'none', marginTop: 2 }} href="#">Blog</Link>
            <Link sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lilneHeight: '145%', letterSpacing: ' 0.015em;', color: '#9EA3AE', textDecoration: 'none', marginTop: 2 }} href="#">How it works</Link>
          </Box>
          <Box className="storeBtn" sx={{ position: 'relative', right: '120px', marginTop: 2 }}>

            <Button><img style={{ width: "158px", height: '55.96px' }} src={appstore} /></Button>
            <Button><img style={{ width: "158px", height: '55.96px' }} src={googleStore} /></Button>

          </Box>
        </Box>
      </Container>

      <Container sx={{ marginLeft: 5 }} maxWidth='lg'>
        <Typography sx={{ fontFamily: 'Outfit', fontWeight: "600", fontSize: '20px', lineHeiht: '140%', letterSpacing: '0.015em', color: "#1A1824", marginTop: 5 }}>Our Officers</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", width: '230px', }}>
          <Typography sx={{ fontFamily: 'Outfit', fontWeight: "400", fontSize: '18px', lineHeight: "145%", color: '#1A1824;', letterSpacing: '0.015em;' }}>Greater Vercouver </Typography>
          <img src={line} />
          <Typography>Victoria</Typography>
        </Box>
        <Typography sx={{ fontFamily: 'Outfit', fontWeight: '400', fontSize: '18px', lineHeight: "140%", color: "#545359;", letterSpacing: '0.015em', marginTop: 2 }}>@ 2021 EatCoast. All Rights Reserved.</Typography>
      </Container>
    </>
  )
}

export {
  About_EatCoast,
  HowItWorks,
  WhyChoseUs,
  Partners,
  Slider_Component,
  OurTeam,
  OurLocation,
  FAQ,
  Footer
}